import { memo } from 'react';

import FigmaCalc1Icon from './FigmaCalc1Icon';
import FigmaInput5Icon from './FigmaInput5Icon';

interface Properties {
  indicatorType: string | undefined;
  size?: number;
}

const iconStyle = { margin: '0 6px', flexShrink: 0 } as const;

/** Calc1/Input5 indicator badges — this module's own icon set. */
const ModernIndicatorIcon = memo(({ indicatorType, size = 20 }: Properties) => {
  const normalizedType = indicatorType?.toLowerCase() ?? '';

  if (normalizedType === 'calculation') {
    return <FigmaCalc1Icon width={size} height={size} style={iconStyle} />;
  }

  if (normalizedType === 'input') {
    return <FigmaInput5Icon width={size} height={size} style={iconStyle} />;
  }

  return null;
});

ModernIndicatorIcon.displayName = 'ModernIndicatorIcon';

export default ModernIndicatorIcon;
